import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET STATISTICS-----------------------------*/
export const getStatistics = createAsyncThunk(
  "statistics/get-statistics",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}statistics`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
